<template>
  <div :class="$style.popup">
    <div :class="$style.content">
      <img :src="`${$cdnLink}/suspend/fuli/close.png`" alt="" @click="close">
      <p>关注<span>【{{ account }}】</span></p>
      <p>{{ text }}</p>
      <p>公众号账号：{{ accountId }}</p>
      <button class="btn1" :data-clipboard-text="accountId" @click="burnReport">一键复制打开微信查看</button>
    </div>
  </div>
</template>

<script>
import Clipboard from "clipboard";
import { gameOpenDownloads } from '@/bridge/AppJsBridge'
import { buryReport } from '@/libs/business/account'

export default {
  name: '',
  props: ['account', 'accountId', 'text', 'type'],
  data () {
    return {
    };
  },
  mounted() {
    this.copyInit()
  },
  methods: {
    close() {
      this.$emit('close');
    },
    burnReport() {
      if (this.type) {
        switch(this.type) {
          case 'messages':
            buryReport('MESSAGE_CLICK_COPY')
            break;
          case 'raiders':
            buryReport('STRATEGY_CLICK_COPY')
            break;
          case 'gift':
            buryReport('GIFT_CLICK_COPY')
            break;
        }
      }
    },
    copyInit() {
      this.clipboard = new Clipboard('.btn1');
      this.clipboard.on('success', () => {
        this.$toast({
          message: '复制成功',
          position: 'bottom'
        });
        gameOpenDownloads({
          gameUrl: 'weixin://'
        })
      })
    }
  },
  beforeDestroy() {
    this.clipboard && this.clipboard.destroy();
  },
}
</script>

<style lang="scss" module>
.popup {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  .content {
    width: 178px;
    height: 136px;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    background: url('//sdk-static.zhangyuqu.com/Lianyun/SdkImg/suspend/fuli/back.png');
    background-size: 100% 100%;
    font-size: 12px;
    text-align: center;
    padding-top: 30px;
    box-sizing: border-box;
    > img {
      position: absolute;
      top: 8px;
      right: 8px;
      width: 10px;
      height: 10px;
    }
    > p {
      line-height: 18px;
      > span {
        color: #FF5B58;
      }
    }
    > button {
      margin-top: 10px;
      background: #FF5B58;
      font-size: 9px;
      border: none;
      width: 147px;
      height: 22px;
      color: #FFFFFF;
      line-height: 22px;
      border-radius: 22px;
    }
  }
}
</style>